import patchRequest from '../../../../patchRequest';

/**
 * Updates the products Name and/or Brand.
 *
 * @param {number} productId - 15974689
 * @param {number} siteId - 1
 * @param {number} brandId - 1
 * @param {number} languageId - 1
 * @returns {Promise} { data: { Success: true, ErrorMessage: null }, status: 200 }
 */
export default async function patchProductBrand(
  productId,
  siteId,
  brandId,
  languageId,
) {
  const endpoint = `/oc-product/v1/product/${productId}/${siteId}/product-brand`;

  const body = {
    brandId,
    languageId,
  };

  return new Promise((resolve, reject) => {
    patchRequest(endpoint, body, 'Update Product Brand')
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}
